import { useState, useEffect } from "react";

export interface TimerProps {
  seconds: number;
  formattedTime: string;
  isRunning: boolean;
  startTimer: () => void;
  stopTimer: () => void;
  resetTimer: () => void;
}

function useTimer(initialSeconds: number = 0): TimerProps {
  const [seconds, setSeconds] = useState<number>(initialSeconds);
  const [isRunning, setIsRunning] = useState<boolean>(false);

  useEffect(() => {
    let timer: any;

    if (isRunning) {
      timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [isRunning]);
  // Stop the timer when seconds reach 0
  const formatTime = (timeInSeconds: number): string => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    const pad = (value: number): string =>
      value < 10 ? `0${value}` : `${value}`;
    if (hours) {
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    } else {
      return `${pad(minutes)}:${pad(seconds)}`;
    }
  };

  const startTimer = (): void => {
    setIsRunning(true);
  };

  const stopTimer = (): void => {
    setIsRunning(false);
  };

  const resetTimer = (): void => {
    setIsRunning(false);
    setSeconds(initialSeconds); // Reset to the initial value passed
  };

  return {
    seconds,
    formattedTime: formatTime(seconds),
    isRunning,
    startTimer,
    stopTimer,
    resetTimer,
  };
}

export default useTimer;
